import React from 'react';
import { Link } from '@zocdoc-frontend-common/components-link';

export const MaxAppointmentErrorDescription = () => {
    return (
        <p data-test="max-appointment-error-description">
            You'll be able to book another appointment after your next
            appointment ends. If you have questions, call us at{' '}
            <Link href="tel:866-962-3621">866-962-3621</Link>
        </p>
    );
};
